import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { MessagesModule }                from '../../app-lite/messages/messages.module';
import { QuickbooksConnectionComponent } from './quickbooks.connection.component';
import { QuickbooksCountryComponent }    from './quickbooks.country.component';
import { QuickbooksSignupComponent }     from './quickbooks.signup.component';
import { QuickbooksStates }              from './quickbooks.states';
import { SharedModule }                  from '../../app-lite/shared/shared.module';

@NgModule({
  declarations: [
    QuickbooksConnectionComponent,
    QuickbooksCountryComponent,
    QuickbooksSignupComponent
  ],
  imports: [
    UIRouterModule.forChild({ states: QuickbooksStates }),

    MessagesModule,
    SharedModule
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class QuickbooksModule {}
